import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { FirebaseObjectObservable } from 'angularfire2/database-deprecated';

import { FirebaseObject } from './firebase-object';
import { FirebaseService } from './firebase-service';

export class FirebaseObjectResolver<T extends FirebaseObject> implements Resolve<FirebaseObjectObservable<T>> {
  constructor(private service: FirebaseService<T>, private router: Router, private parent?: boolean) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<FirebaseObjectObservable<T>> {
    const id = route.params['id'];
    const parentId = this.parent ? route.parent.parent.params['id'] : null;
    return Promise.resolve(this.service.readChild(id, parentId));
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/firebase/firebase-object-resolver.ts